import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import clx from 'classnames';
import { ErrorBoundary } from 'client/blocks/ErrorBoundary/ErrorBoundary';
import { CheckIcon } from 'client/blocks/icons/CheckIcon';
import { routes } from 'client/lib/routes';
import { IAppCard } from 'client/model/skill';

import { moment } from '../../lib/moment';

import styles from './AllAvailableApps.module.scss';

interface Props {
    card: IAppCard;
}

export const AllAvailableAppsCard: FC<Props> = ({ card }) => {
    return (
        <ErrorBoundary>
            <Link
                to={routes.app.installableAppSettings(card.channel, false, 'main', card.id)}
                className={styles.container}
            >
                <div className={styles.content}>
                    <div className={styles.icon__container}>
                        <img className={styles.icon__imageShadow} src={card.logoUrl} />
                        <div className={clx(styles.icon__content, !card.logoUrl && styles.icon__content_empty)}>
                            {card.logoUrl && (
                                <>
                                    <img
                                        className={styles.icon__image}
                                        src={card.logoUrl}
                                        alt={`YaOS app logo ${card.title}`}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                    <div className={styles.headerContainer}>
                        <h3 className={clx(styles.title, !card.publishedAt && styles.title_wide)}>{card.title}</h3>
                        {card.publishedAt ? (
                            <div className={styles.published__container}>
                                {moment(card.publishedAt).format('DD.MM.YY')}
                                <CheckIcon />
                            </div>
                        ) : null}
                    </div>
                </div>
            </Link>
        </ErrorBoundary>
    );
};
